import container from "@/lib/di/container";
import { Suspense, useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable, TablePaginationData } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, Dropdown, message, Modal, Popconfirm, Tooltip } from "antd";
import { CheckCircleOutlined, CloseOutlined, DeleteOutlined, ExportOutlined, FileExcelOutlined, HistoryOutlined, InfoCircleOutlined, MoreOutlined, PayCircleOutlined, ScheduleOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { WaterIndexModel, WaterIndexModelFactory } from "@/core/models/water-index.model";
import { WaterIndexRepo } from "@/core/repos/tables/water-index.repo";
import { TollAreaRepo } from "@/core/repos/tables/toll-area.repo";
import { GlobalUtils } from "../../utils/global.utils";
import { UserRepo } from "@/core/repos/user.repo";
import { DifferenceCell } from "../components/DifferenceCell";
import { DeleteButton } from "../../components/table/DeleteButton";
import { ApprovalModal } from "./modals/ApprovalModal";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { ContractRepo } from "@/core/repos/tables/contract.repo";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import { WaterIndexStatus } from "@/core/enums/global.enums";
import { waterIndexStatusTagPipe } from "@/core/pipes/water-index-status.pipe";
import { useNavigate, useSearchParams } from "react-router";
import { InitWaterIndexModal } from "./modals/InitWaterIndexModal";
import { ExportInvoiceMonthModal } from "./modals/ExportInvoiceMonthModal";
import AuthRepo from "@/core/repos/auth.repo";
import { PERMISSIONS } from "@/core/enums/permissions.enum";

const waterIndexRepo = container.get(WaterIndexRepo);
const waterInvoiceRepo = container.get(WaterInvoiceRepo);
const tollAreaRepo = container.get(TollAreaRepo);
const userRepo = container.get(UserRepo);
const contractRepo = container.get(ContractRepo);
const authRepo = container.get(AuthRepo);

function WaterIndex() {
    const titleData = useTitleDataStore();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const claims = authRepo.useClaims();
    const waterUserId = searchParams.get('waterUserId');
    const [modalData, setModalData] = useState<WaterIndexModel>(WaterIndexModelFactory.getEmpty())
    const [isInitWaterIndexModal, setInitWaterIndexModal] = useState(false);
    const [isExportInvoiceMonth, setExportInvoiceMonth] = useState(false);
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map(
        Object.entries({...waterUserId?{}:GlobalUtils.getPreviousMonthFilter()})
    ))
    const [selectedRows, setSelectedRows] = useState<WaterIndexModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isApprovalModal, setApprovalModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [disapproving, setDisapproving] = useState(false);
    const [isIniting, setIniting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [pagination, setPagination] = useState<TablePaginationData>({current: 1, pageSize: 10});
    const [approveIndex, setApproveIndex] = useState<number>(1);
    const [filterTemplates, setFilterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
        {
            dataIndex: "month",
            label: "Tháng",
            placeholder: "Chọn tháng",
            type: FilterInputType.month,
        },
        {
            dataIndex: "tollAreaId",
            label: "Khu vực",
            placeholder: "Chọn Khu vực",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "status",
            label: "Trạng thái đọc",
            placeholder: "Chọn trạng thái đọc",
            type: FilterInputType.select,
            options: [
                {value: null, name: "Tất cả"},
                {value: "read", name: "Đã đọc"},
                {value: "unread", name: " Chưa đọc"},
            ]
        },
        {
            dataIndex: "indexStatus",
            label: "Trạng thái duyệt",
            placeholder: "Chọn trạng thái duyệt",
            type: FilterInputType.select,
            options: [
                {value: null, name: "Tất cả"},
                {value: WaterIndexStatus.CONFIRMED, name: "Đã duyệt"},
                {value: WaterIndexStatus.COMPLETED, name: "Chờ duyệt"},
                {value: WaterIndexStatus.CANCELLED, name: "Bị hủy"},
            ],
            disabled: true
        },
        {
            dataIndex: "useAmountWaterIndex",
            label: "Lượng tiêu thụ",
            placeholder: "Nhập lượng tiêu thụ",
            type: FilterInputType.number,
            disabled: true
        },
        {
            dataIndex: "differenceRatio",
            label: "Biến động % tối thiểu",
            placeholder: "Nhập % biến động cần tra cứu",
            type: FilterInputType.number,
            disabled: true
        },
        {
            dataIndex: "createdBy",
            label: "Người đọc",
            placeholder: "Chọn Người đọc",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "hasInvoice",
            label: "Trạng thái hóa đơn",
            placeholder: "Chọn trạng thái hóa đơn",
            type: FilterInputType.select,
            options: [
                {value: null, name: "Tất cả"},
                {value: true, name: "Đã tạo hóa đơn"},
                {value: false, name: "Chưa tạo hóa đơn"},
            ]
        },
    ])

    const showDetail = (record: WaterIndexModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const showApproval = () => {
        setApprovalModal(true);
    }
    const showInitWaterIndex = () => {
        setInitWaterIndexModal(true);
    }
    const showApprovalOf = (record: WaterIndexModel) => {
        setApproveIndex(Number(record.key??"1"));
        setApprovalModal(true);
    }

    const showExportInvoiceMonth = () => {
        setExportInvoiceMonth(true);
    }

    const showReports = () => {
        const params = GlobalUtils.buildQueryParamsFromFilterMap(filterMap);
        navigate(encodeURI(`/meter-reading/index-report?${params}`));
    }

    const showLogs = (record: WaterIndexModel) => {
        navigate(encodeURI(`/admin/logs?search=${record.id}&objectType=WaterIndex`));
    };

    const createInvoice = async (record: WaterIndexModel) => {
        Modal.confirm({
            title: `Xuất hóa đơn cho chỉ số nước`,
            content: `Xuất hóa đơn cho chỉ số nước tháng ${record.month}/${record.year} của khách hàng ${record.waterUser?.code} - ${record.waterUser?.name}`,
            okText: "Xuất hóa đơn",
            onOk: async () => {
                const result = await waterInvoiceRepo.createInvoiceWithIndex(record);
                if (result === true) {
                    message.success("Xuất hóa đơn cho chỉ số thành công");
                } else {
                    message.error(typeof result === "string"?result:"Xuất hóa đơn thất bại");
                }
            },
        });

    }

    useEffect(() => {
        setApproveIndex((pagination.current-1)*pagination.pageSize);
    }, [pagination]);

    const populateSelections = async () => {
        const tollAreas = (await tollAreaRepo.getAll()).map(r => ({name: r.name, value: r.id}));
        const users = (await userRepo.getFromFactory()).map(r => ({name: `${r.fullName}-${r.userName.toUpperCase()}`, value: r.userName}))
        const templates: FilterInputTemplate[] = [...filterTemplates];
        const tollAreaTemplate = templates.find(template => template.dataIndex === "tollAreaId");
        if (tollAreaTemplate) {
            tollAreaTemplate.options = tollAreas;
        }
        const userTemplate = templates.find(template => template.dataIndex === "createdBy");
        if (userTemplate) {
            userTemplate.options = users;
        }
        setFilterTemplates(templates);
    }

    const init = async () => {
        await populateSelections();
        if (waterUserId) {
            const contract = await contractRepo.detail(waterUserId);;
            if (contract) {
                titleData.setTitleBack(true);
                titleData.setTitleText(`Chỉ số nước - ${contract.code} - ${contract.name}`)
            }
        }
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await waterIndexRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }

    const disapproveSelected = async () => {
        setDisapproving(true);
        const result = await waterIndexRepo.disapproveMany(selectedRows);
        messageApi.success({
            content: `Bạn đã hủy duyệt thành công ${result.success}/${result.total} chỉ số nước`
        })
        setDisapproving(false);
    }


    async function onFilterChange(map: Map<string, FilterSearchPayload>, changes: string[]) {
        let isDirty = false;
        const templates = [...filterTemplates]

        const status = map.get("status")?.value;
        const disabled = status != "read";

        const useAmountWaterIndexTemplate = templates.find(t => t.dataIndex === "useAmountWaterIndex");
        if (useAmountWaterIndexTemplate) {
            useAmountWaterIndexTemplate.disabled = disabled;
            isDirty = true;
        }

        const differenceRatioTemplate = templates.find(t => t.dataIndex === "differenceRatio");
        if (differenceRatioTemplate) {
            differenceRatioTemplate.disabled = disabled;
            isDirty = true;
        }

        const indexStatusTemplate = templates.find(t => t.dataIndex === "indexStatus");
        if (indexStatusTemplate) {
            indexStatusTemplate.disabled = disabled;
            isDirty = true;
        }

        if (disabled) {
            map.delete("useAmountWaterIndex");
            map.delete("differenceRatio");
            map.delete("indexStatus");
        }

        if (isDirty) {
            setFilterTemplates(templates)
        }
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: WaterIndexModel[]) {
        setSelectedRows([...rows]);
    }

    function onPagination(current: number, pageSize: number) {
        setPagination({current, pageSize});
    }

   

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="col-span-4">
                <Button type="primary" icon={<FileExcelOutlined />} style={{ background: "#29A339"}} onClick={showReports}>Xuất Excel</Button>
                <Button 
                    className='ml-4'
                    type="primary"
                    onClick={showExportInvoiceMonth}
                    icon={<ExportOutlined />}
                    style={{ background: "var(--primary-button)"}}>Tạo bảng tính phí</Button>
                <Button 
                    loading={isIniting}
                    className='ml-4'
                    type="primary"
                    onClick={showInitWaterIndex}
                    icon={<ScheduleOutlined />}
                    style={{ background: "var(--primary-button)"}}>Khởi tạo Chỉ số nước</Button>
                <Button 
                    className='ml-4'
                    type="primary"
                    onClick={showApproval}
                    icon={<CheckCircleOutlined />}
                    style={{ background: "var(--primary-button)"}}>Duyệt chỉ số nước</Button>
                <Popconfirm
                    title={`Hủy duyệt ${selectedRows.length} chỉ số nước?`}
                    description={`Bạn có chắc chắn muốn hủy duyệt ${selectedRows.length} chỉ số nước đã chọn?`}
                    onConfirm={disapproveSelected}
                    okText="Hủy duyệt"
                    cancelText="Huỷ"
                >
                    <Button className='ml-4' loading={disapproving} type="primary" danger icon={<CloseOutlined />} disabled={selectedRows.length === 0}>Hủy duyệt</Button>
                </Popconfirm>
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<WaterIndexModel>
                columns={[
                    { name: 'Tháng', pipe: (value: WaterIndexModel) => value.month+"/"+value.year },
                    { name: 'Mã hợp đồng', pipe: (value: WaterIndexModel) => value.waterUser?.code??"" },
                    { name: 'Đại diện hợp đồng', pipe: (value: WaterIndexModel) => value.waterUser?.name??"" },
                    { name: 'Mã đồng hồ nước', dataIndex: 'waterMeterCode',},
                    { name: 'Khu vực', pipe: (value: WaterIndexModel) => value.tollArea?.name??"" },
                    { dataIndex: 'waterMeterNumber', name: 'Số đồng hồ' },
                    { dataIndex: 'oldNumber', name: 'Số đo cũ' },
                    { dataIndex: 'useAmount', name: 'Khối dùng' },
                    { dataIndex: 'differenceRatio', name: 'Chênh lệch', render: (percent) => percent?<DifferenceCell percent={percent} />:null, fixed: "right"},
                    { dataIndex: 'createdAt', name: 'Ngày đo', pipe: formatDateTimePipe },
                    { dataIndex: 'createdBy', name: 'Người đo' },
                    { dataIndex: 'status', name: 'Trạng thái', pipe: (value) => waterIndexStatusTagPipe(value, {
                        textAlign: "center",
                    }), fixed: "right" },
                    {
                        name: '',
                        render: (_, record) => (
                            <div className="flex flex-row px-1 items-center justify-center">
                            <Tooltip title="Sửa Chỉ số nước"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                            <Dropdown menu={{items: [
                                {
                                    key: '1',
                                    label: <p>Xuất hóa đơn</p>,
                                    icon: <PayCircleOutlined />,
                                    onClick: () => createInvoice(record)
                                },
                                {
                                    key: '2',
                                    label: <p>Duyệt chỉ số</p>,
                                    icon: <CheckCircleOutlined />,
                                    onClick: () => showApprovalOf(record),
                                },
                                {
                                    key: '3',
                                    label: <p>Xem nhật ký</p>,
                                    icon: <HistoryOutlined />,
                                    onClick: () => showLogs(record),
                                    disabled: !GlobalUtils.checkPerm(claims, PERMISSIONS.AUDITLOG_VIEW.key),
                                },
                            ]}} trigger={["hover"]}>
                                <Button type="text" icon={<MoreOutlined />}/>
                            </Dropdown>
                            
                        </div>
                        ),
                        fixed: "right",
                        width: 50
                    },
                ]}
                repository={waterIndexRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
                onPagination={onPagination}
                defaultParams={{waterUserId}}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
        <ApprovalModal isModalOpen={isApprovalModal} setIsModalOpen={setApprovalModal} filterMap={filterMap} defaultParams={{waterUserId}} index={approveIndex}></ApprovalModal>
        {isInitWaterIndexModal && <InitWaterIndexModal isModalOpen={isInitWaterIndexModal} setIsModalOpen={setInitWaterIndexModal} data={{total: 0, filterMap}}></InitWaterIndexModal>}
        {isExportInvoiceMonth && <ExportInvoiceMonthModal isModalOpen={isExportInvoiceMonth} setIsModalOpen={setExportInvoiceMonth} data={{
            month: filterMap.get("month")?.value??GlobalUtils.getPreviousMonthFilter().month.value,
            year: filterMap.get("year")?.value??GlobalUtils.getPreviousMonthFilter().year.value,
            tollAreaId: filterMap.get("tollAreaId")?.value
        }}></ExportInvoiceMonthModal>}
    </div>)
}

export default function WaterIndexPage() {
    return <Suspense>
        <WaterIndex />
    </Suspense>
}